export default "__VITE_ASSET__CyGf_hnR__"